/* FanGlow: update the visible bundle total for mixed-price variants.
   Actual discounts are controlled by automatic discounts in Shopify admin. */
(() => {
  function formatCents(cents, currency) {
    const locale = document.documentElement.lang || 'sv-SE';
    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency', currency: currency || 'SEK'
      }).format(cents / 100);
    } catch (_error) {
      return (cents / 100).toFixed(2) + ' ' + (currency || 'SEK');
    }
  }

  function updateBundlePrice(offer) {
    const container = offer.closest('.quantity-breaks-container');
    if (!container || container.dataset.variantsEnabled !== 'true') return;
    const selects = Array.from(offer.querySelectorAll('.quantity-break__variant-select'));
    if (!selects.length) return;

    let regularTotal = 0;
    let compareTotal = 0;
    selects.forEach((select) => {
      const selectedOption = select.selectedOptions[0];
      if (!selectedOption) return;
      const price = Number(selectedOption.dataset.price) || 0;
      const compare = Number(selectedOption.dataset.comparePrice) || 0;
      regularTotal += price;
      compareTotal += compare > price ? compare : price;
    });

    let discountedTotal = regularTotal;
    if (offer.dataset.discountType === 'percentage') {
      discountedTotal = Math.round(regularTotal * (1 - (Number(offer.dataset.percentOff) || 0) / 100));
    } else if (offer.dataset.discountType === 'fixed_amount') {
      discountedTotal = Math.max(0, regularTotal - (Number(offer.dataset.fixedOff) || 0));
    }

    const caption = offer.querySelector('.quantity-break__caption');
    if (caption && offer.dataset.captionTemplate) {
      const discountType = offer.dataset.discountType;
      const savings = discountType === 'percentage'
        ? `${Number(offer.dataset.percentOff) || 0}%`
        : formatCents(regularTotal - discountedTotal, container.dataset.currency);
      caption.textContent = offer.dataset.captionTemplate
        .replaceAll('[qty]', String(selects.length))
        .replaceAll('[item_price]', formatCents(Math.round(discountedTotal / selects.length), container.dataset.currency))
        .replaceAll('[total_price]', formatCents(discountedTotal, container.dataset.currency))
        .replaceAll('[discount]', savings);
    }
    const price = offer.querySelector('.quantity-break__price');
    const compare = offer.querySelector('.quantity-break__compare-price');
    if (price) price.textContent = formatCents(discountedTotal, container.dataset.currency);
    if (compare) {
      const showCompare = compareTotal > discountedTotal;
      compare.textContent = formatCents(compareTotal, container.dataset.currency);
      compare.style.display = showCompare ? '' : 'none';
    }
  }

  document.addEventListener('change', (event) => {
    if (!event.target.matches('.quantity-break__variant-select')) return;
    const offer = event.target.closest('.quantity-break');
    if (offer) updateBundlePrice(offer);
  });
  // Recalculation also works when Shopify replaces the bundle HTML via its variant picker.
  const refreshBundles = () => {
    document.querySelectorAll('.quantity-breaks-container[data-variants-enabled="true"] .quantity-break').forEach(updateBundlePrice);
  };
  document.addEventListener('DOMContentLoaded', refreshBundles);
  document.addEventListener('shopify:section:load', refreshBundles);
})();
